import { ZoneCreationProperties } from '../types/zoneMapType';

export interface ExclusiveOwnershipResult {
  isValid: boolean;
  duplicates: Map<string, string[]>;
}

/**
 * Validates that no fixture ID appears in more than one zone's fixtureIds array.
 * Returns a map of duplicate fixture IDs to the zone names they appear in.
 */
export function validateExclusiveFixtureOwnership(
  zoneCreationProperties: Map<number, ZoneCreationProperties>,
): ExclusiveOwnershipResult {
  const fixtureToZones = new Map<string, string[]>();

  for (const [, zone] of zoneCreationProperties) {
    for (const fixtureId of zone.fixtureIds) {
      const zones = fixtureToZones.get(fixtureId);
      if (zones) {
        zones.push(zone.zoneName);
      } else {
        fixtureToZones.set(fixtureId, [zone.zoneName]);
      }
    }
  }

  const duplicates = new Map<string, string[]>();
  for (const [fixtureId, zones] of fixtureToZones) {
    if (zones.length > 1) {
      duplicates.set(fixtureId, zones);
    }
  }

  return { isValid: duplicates.size === 0, duplicates };
}
